// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Assets
import arrowRigth from "./assets/arrowRigth.svg";

// Components
import { WebpImageDoubt } from "components/WebpImageDoubt";

type WebpNotificationPubProps = {
    isNotRead: boolean;
    hasButton?: boolean;
    time?: string;
    badge?: string;
    message: string;
    photoUser?: string;
    labelButton: string;
    lessonTheme?: string;
    onClickLookAnswer: () => void;
    onClickNotificationPub: () => void;
};

export const WebpNotificationPub: FunctionComponent<WebpNotificationPubProps> = ({
    time,
    badge,
    message,
    photoUser,
    labelButton,
    lessonTheme,
    onClickLookAnswer,
    hasButton = false,
    isNotRead = false,
    onClickNotificationPub
}) => {
    const handleCardClicked = () => {
        onClickNotificationPub();
    };

    const handleButtonClicked = () => {
        onClickLookAnswer();
    };

    return (
        <Container isNotRead={isNotRead} onClick={() => handleCardClicked()}>
            {isNotRead && <div className="dot" />}

            <WebpImageDoubt photoUser={photoUser} badge={badge}></WebpImageDoubt>

            <div className="description-time">
                <div className="description-name">
                    <div className="description" dangerouslySetInnerHTML={{ __html: message }}></div>
                    {lessonTheme && <p className="lesson-theme">{lessonTheme}</p>}
                </div>

                <div className="time-button">
                    {time && <p className="time">{time}</p>}
                    {hasButton && (
                        <button className="button-action" onClick={() => handleButtonClicked()}>
                            {labelButton} <img className="arrow-rigth" src={arrowRigth} alt="arrow" />
                        </button>
                    )}
                </div>
            </div>
        </Container>
    );
};
